import ListTemplate from "components/ListTemplate";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { routes } from "utilities/routing/generatedRoutes";
import { cardLayout } from "./cardLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";

const BankAccountList = () => {
  const viewModel = useLoaderData<server.viewmodel.BankAccountListFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={viewModel.pageTitle}
        filterSet="bankAccount_List"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={window.CoreApi.BankAccount.ListBankAccount}
        getId={item => item.bankAccountId}
        onNew={() => window.location.href = routes.bankAccount_New().absolute}
        layout={cardLayout()}
        filters={<>
          <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction
        }}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>;
};

export default BankAccountList;